import app from './modules/app';
import parkingLots from './modules/parking-lots';
import variables from './modules/variables';
import folders from './modules/folders';
import devices from './modules/devices';
import navigation from './modules/navigation';
import metrics from './modules/metrics';

export default {
  app,
  parkingLots,
  variables,
  folders,
  devices,
  navigation,
  metrics,
};
